export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "indexing.worker.39f685a254054a93720d.worker.js");
}
